module.exports = __webpack_public_path__ + "media/images/More-742b964384c60c9799c10db1d17211f6.svg";